import React, { useEffect } from "react";

import ActionList from "../../../templates/student/ActionList";
import {
  Context,
  fetchActionList,
  submitRealization,
} from "../../../studentStore";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import * as MESSAGE from "../../../studentStore/messages";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);

  useEffect(() => {
    dispatch(fetchActionList());
  }, [dispatch]);

  useEffect(() => {
    if (state.success_message === MESSAGE.SUBMIT_REALIZATION_SUCCESS_MSG) {
      dispatch(fetchActionList());
    }
  }, [dispatch, state.success_message]);

  const handleSubmitRealization = React.useCallback(
    (lesson_id: number, content: string, realization_id: number | null) => {
      dispatch(peep(submitRealization(lesson_id, content, realization_id)));
    },
    [dispatch, peep],
  );

  return (
    <ActionList
      actionList={state.action_list}
      handleSubmitRealization={handleSubmitRealization}
      calling={calling}
    />
  );
};
